<template>
  <div id="app">
    <el-container>
      <el-header>
        <uiHeader></uiHeader>
      </el-header>
      <el-main>
        <div
          style="
            background-color: #ffffff;
            margin-bottom: 1rem;
            position: relative;
            padding: 0.5rem;
            text-align: left;
          "
        >
          <span style="font-size: 1rem; font-weight: bold">设备列表</span>
          <div style="position: absolute; right: 1rem; top: 0.3rem">
            <el-button
              icon="el-icon-plus"
              circle
              size="mini"
              @click="addDeviceToGb()"
            ></el-button>
          </div>
        </div>
        <!-- <devicePlayer ref="devicePlayer"></devicePlayer> -->
        <!--设备列表-->
        <el-table
          :data="deviceList"
          border
          style="width: 100%; font-size: 12px"
          :height="winHeight"
        >
          <el-table-column prop="platformName" label="平台名称" align="center">
          </el-table-column>
          <el-table-column prop="serverGbCode" label="服务器ID" align="center">
          </el-table-column>
          <el-table-column
            prop="serverDomain"
            width="180"
            label="服务域名"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="ip" width="180" label="服务IP" align="center">
          </el-table-column>

          <el-table-column
            label="操作"
            width="500"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button-group>
                <el-button
                  size="mini"
                  icon="el-icon-edit"
                  type="primary"
                  @click="edit(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  icon="el-icon-edit"
                  type="primary"
                  @click="shareFn(scope.row)"
                  >共享</el-button
                >
                <el-button
                  size="mini"
                  icon="el-icon-view"
                  type="primary"
                  @click="view(scope.row)"
                  >详情</el-button
                >
                <el-button
                  size="mini"
                  icon="el-icon-delete"
                  type="danger"
                  @click="deleteDevice(scope.row)"
                  >删除</el-button
                >
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float: right"
          @size-change="handleSizeChange"
          @current-change="currentChange"
          :current-page="currentPage"
          :page-size="count"
          :page-sizes="[150, 200, 250, 300]"
          layout="total, sizes, prev, pager, next"
          :total="total"
        >
        </el-pagination>
        <HandleSharePlatformDlg
          ref="addDeviceDlg"
          :handleType="handleType"
          :row="row"
          :dialogTitle="dialogTitle"
          @close="showHanleDlg = false"
          @success="successFn"
          v-if="showHanleDlg"
        />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import uiHeader from "./UiHeader.vue";
import HandleSharePlatformDlg from "./dialog/HandleSharePlatformDlg.vue";

export default {
  name: "app",
  components: {
    uiHeader,
    HandleSharePlatformDlg,
  },
  data() {
    return {
      deviceList: [], //设备列表
      updateLooper: 0, //数据刷新轮训标志
      winHeight: window.innerHeight - 200,
      currentPage: 1,
      count: 150,
      total: 0,
      getDeviceListLoading: false,
      showHanleDlg: false,
      row: {},
      dialogTitle: "",
    };
  },
  mounted() {
    this.initData();
    this.updateLooper = setInterval(this.initData, 10000);
  },
  destroyed() {
    this.$destroy("videojs");
    clearTimeout(this.updateLooper);
  },
  methods: {
    initData: function () {
      this.getDeviceList();
    },
    currentChange: function (val) {
      this.currentPage = val;
      this.getDeviceList();
    },
    handleSizeChange: function (val) {
      this.count = val;
      this.getDeviceList();
    },
    getDeviceList: function () {
      let that = this;
      this.getDeviceListLoading = true;
      this.$axios({
        method: "get",
        url: `/api/share/platforms/get`,
        params: {
          page: that.currentPage,
          step: that.count,
          token: this.$cookies.get("session").token,
        },
      })
        .then(function (res) {
          var data = res.data;
          if (data.code == 0) {
            var ret_data = data.data;
            that.total = ret_data.rowCount;
            that.deviceList = ret_data.platforms;
          } else {
            console.log(data);
          }
          that.getDeviceListLoading = false;
        })
        .catch(function (error) {
          console.error(error);
          that.getDeviceListLoading = false;
        });
    },
    deleteDevice: function (row) {
      const msg = "确定删除此平台？";
      this.$confirm(msg, "提示", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        type: "warning",
      })
        .then(() => {
          this.$axios({
            method: "post",
            url: `/api/share/platforms/delete`,
            data: {
              platformIds: [row.id],
            },
            params: {
              token: this.$cookies.get("session").token,
            },
          })
            .then((res) => {
              if (res.data.code != 0) {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: "error",
                });
              } else {
                this.$message({
                  message: res.data.msg || "删除成功",
                  type: "success",
                });
              }
              this.getDeviceList();
            })
            .catch((error) => {
              console.error(error);
            });
        })
        .catch(() => {});
    },
    edit(row) {
      this.row = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑平台";
      this.handleType = "edit";
      this.showHanleDlg = true;
    },
    addDeviceToGb() {
      this.handleType = "add";
      this.dialogTitle = "添加平台";
      this.row = {};
      this.showHanleDlg = true;
    },
    view(row) {
      this.row = JSON.parse(JSON.stringify(row));
      this.handleType = "view";
      this.dialogTitle = "平台详情";
      this.showHanleDlg = true;
    },
    shareFn(row) {
      this.$router.push(`/transformation/${row.id}`);
    },
    successFn() {
      this.getDeviceList();
    },
  },
  beforeDestroy() {
    clearInterval(this.updateLooper);
    this.updateLooper = null;
  },
};
</script>

<style>
.videoList {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.video-item {
  position: relative;
  width: 15rem;
  height: 10rem;
  margin-right: 1rem;
  background-color: #000000;
}

.video-item-img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
}

.video-item-img:after {
  content: "";
  display: inline-block;
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 3rem;
  height: 3rem;
  background-image: url("../assets/loading.png");
  background-size: cover;
  background-color: #000000;
}

.video-item-title {
  position: absolute;
  bottom: 0;
  color: #000000;
  background-color: #ffffff;
  line-height: 1.5rem;
  padding: 0.3rem;
  width: 14.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/sharePlatform.vue